import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api/portal`;

const withToken = (key) => {
  const inst = axios.create({ baseURL: API });
  inst.interceptors.request.use((cfg) => {
    const t = localStorage.getItem(key);
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    return cfg;
  });
  return inst;
};

export const publicApi = axios.create({ baseURL: API });
export const residentApi = withToken("bsk_resident_token");
export const adminApi = withToken("bsk_admin_token");

export const errMsg = (e, fallback = "Bir hata oluştu") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return "Lütfen alanları kontrol edin";
  return fallback;
};

export const imgUrl = (path, fallback = "/on_kapi_girisi.jpg") => (path ? `${API}/files/${path}` : fallback);
